import { Component, OnInit, ViewChild } from '@angular/core';
import { UserDb, User } from '../../../providers/user';
import { Plan, PlanesProvider } from '../../../providers/planes';
import { AuthProvider } from '../../../providers/auth';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

    planes: Plan[] = [];
    usuariosTableActive: UserDb[] = [];
    usuariosTableNotActive: UserDb[] = [];
    usuariosPapelera: UserDb[] = [];
    userNew: UserDb = new UserDb();
    userNewErrors = false;
    userConfirmDeletePreviousRegistration: UserDb = null;
    userConfirmDelete: UserDb = null;

    private _success = new Subject<string>();
    successMessage: string;

    @ViewChild('contentModalConfirmDeletePreviousRegistration') contentModalConfirmDeletePreviousRegistration;
    modalConfirmDeletePreviousRegistration: NgbModalRef;

    @ViewChild('contentModalConfirmDeleteUser') contentModalConfirmDeleteUser;
    modalConfirmDeleteUser: NgbModalRef;

    constructor(private _auth: AuthProvider, private _planes: PlanesProvider, private _users: User, public modalService: NgbModal) { }

    activateUser(usuario: UserDb) {
        this._users.removeTheUserFromTheTrash(usuario).then(_ => {
            this.usuariosPapelera = this.usuariosPapelera.filter(u => u.id != usuario.id);
            this.usuariosTableActive.push(usuario);
            this._success.next('Se ha sacado de la papelera al usuario correctamente');
        });
    }

    banUser(usuario: UserDb) {
        this._users.updateChild(usuario.id, 'baneado', !usuario.baneado).then(_ => {
            usuario.baneado = !usuario.baneado;
            let message: string = (usuario.baneado) ? 'El usuario se ha bloqueado / baneado de la aplicación' : 'Se ha dado acceso al usuario en la aplicación';
            this._success.next(message);
        });
    }

    confirmDeletePreviousRegistration() {
        this._users.removePreviousRegistration(this.userConfirmDeletePreviousRegistration.id).then(_ => {
            this.usuariosTableNotActive = this.usuariosTableNotActive.filter(u => u.id != this.userConfirmDeletePreviousRegistration.id);
            this.userConfirmDeletePreviousRegistration = null;
            this.modalConfirmDeletePreviousRegistration.close();
            this._success.next('Se ha borrado el link de activación correctamente');
        });
    }

    confirmDeleteUser() {
        this._users.moveToTrashUser(this.userConfirmDelete).then(_ => {
            this.usuariosTableActive = this.usuariosTableActive.filter(u => u.id != this.userConfirmDelete.id);
            this.usuariosPapelera.push(this.userConfirmDelete);
            this.modalConfirmDeleteUser.close();
            this.userConfirmDelete = null;
            this._success.next('Se ha borrado al usuario correctamente');
        });
    }

    cancelConfirmDeletePreviousRegistration() {
        this.userConfirmDeletePreviousRegistration = null;
        this.modalConfirmDeletePreviousRegistration.close();
    }

    cancelConfirmDeleteUser() {
        this.modalConfirmDeleteUser.close();
        this.userConfirmDelete = null;
    }

    deleteRegistroPrevio(usuario) {
        this.modalConfirmDeletePreviousRegistration = this.modalService.open(this.contentModalConfirmDeletePreviousRegistration, { windowClass: 'intra-modal-lg' });
        this.userConfirmDeletePreviousRegistration = usuario;
    }

    ngOnInit() {
        this._planes.all().then(planes => {
            this.planes = planes;
            this.resetNewUser();
            this._users.all('user').then(users => {
                users = users.filter(u => (u.planes));
                this.usuariosTableActive = users;
                /* users.forEach(user => {
                    // if(user.id != 'hlMMjQsJa9bBL43vNn7i7qYLWB73'){
                        this._planes.findByUserQrs(user.id).then(pqrs => {
                            console.log('user', user.id, 'proyects', pqrs);
                            let i = 0;
                            pqrs.forEach(pqr => {
                                // this._planes.storeRedirectPqr(user.id, pqr);
                                i++;
                                pqr.info = user.telefono;
                                pqr.pass = '123456';
                                pqr.name = (pqr.name == '') ? 'Proyecto Qr ' + i : pqr.name;
                                this._planes.updateQr(user.id, pqr);
                            });
                        });
                    // }
                }) */
                this._users.allPreviousRegistration('user').then(users => {
                    this.usuariosTableNotActive = users;
                    this._users.allDelete().then(users => {
                        this.usuariosPapelera = users;
                    });
                });
            });
        });

        this._success.subscribe((message) => this.successMessage = message);
        this._success.pipe(
            debounceTime(5000)
        ).subscribe(() => this.successMessage = null);
    }

    newUser() {
        if (this.userNew.email == '' || this.userNew.name == '') {
            this.userNewErrors = true;
            return true;
        }

        this._users.storePreviousRegistration(this.userNew).then((user) => {
            this._auth.sendSignInLinkToEmail(this.userNew.email, user.id).then(m => {
                this.usuariosTableNotActive.push(user);
                this.resetNewUser();
                this._success.next(`Usuario creado correctamente, se ha enviado un correo al email especificado.`);
            }).catch(e => {
                console.log(e);
            });
        })

    }

    openModalDeleteUser(usuario) {
        this.modalConfirmDeleteUser = this.modalService.open(this.contentModalConfirmDeleteUser, { windowClass: 'intra-modal-lg' });
        this.userConfirmDelete = usuario;
    }

    reenvionEmailActivate(usuario: UserDb) {
        console.log(usuario);
        this._auth.sendSignInLinkToEmail(usuario.email, usuario.id).then(m => {
            console.log(m);
            this._success.next(`Se ha enviado un correo al email del usuario.`);
        });
    }

    resetNewUser() {
        this.userNew = new UserDb();
        this.userNew.planes.push(this.planes[0].id);
        this.userNew.role = 'user';
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/dash/users/users.component.ts